export const defaultCustomerDetailsFormData = {
    givenName: '',
    familyName: '',
    email: '',
    phoneNumber: ''
};
